import { Component, Inject, OnInit } from '@angular/core';
import {
	DefaultMatterAdjustmentTarion,
	MatterAdjustmentSalePrice,
	MatterAdjustmentSalePriceCalculated,
	MatterAdjustmentTarion,
	NetOutHstOptions,
	TarionRateTableOption,
	TarionSaleAmountOptions,
} from '@models/matter';
import { cloneDeep } from 'lodash';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ICON } from '@core/util/icon';
import { calculateTarionWarranty } from '../../../../shared/services/adjustments';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { AdjustmentDefaultDetailsSelectors } from '@state/global/adjustment-details';
import { DropdownOption } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { TestHooks } from './tarrion-warranty-dialog.hooks';

export interface TarionDialogData {
	adjustmentId?: string;
}

const TarionRateTableOptionName = {
	[TarionRateTableOption.RATE_TABLE_2021]:
		'On or after Feb 1, 2021 and before Jan 1, 2024',
	[TarionRateTableOption.RATE_TABLE_2024]: 'On or after Jan 1, 2024',
};

const EnrolmentDateOptions: DropdownOption<TarionRateTableOption>[] = [
	{
		name: TarionRateTableOptionName[TarionRateTableOption.RATE_TABLE_2021],
		value: TarionRateTableOption.RATE_TABLE_2021,
	},
	{
		name: TarionRateTableOptionName[TarionRateTableOption.RATE_TABLE_2024],
		value: TarionRateTableOption.RATE_TABLE_2024,
	},
];

@Component({
	selector: 'app-tarion-warranty',
	templateUrl: './tarrion-warranty-dialog.component.html',
	standalone: false,
})
export class TarrionWarrantyDialogComponent implements OnInit {
	testHooks = TestHooks;
	adjustment: MatterAdjustmentTarion = cloneDeep(DefaultMatterAdjustmentTarion);
	@SelectSnapshot(
		AdjustmentDefaultDetailsSelectors.adjustmentDetailsTarionWarranty,
	)
	public adjustmentDetails: boolean;
	creditAmount: number;
	creditItems = [
		{
			label: 'Vendor',
			value: 'vendor',
		},
		{
			label: 'Purchaser',
			value: 'purchaser',
		},
		{
			label: 'No adjustment',
			value: 'none',
		},
	];

	enrolmentFee: number;
	hstAmount: number;
	id: string;
	readonly ICON = ICON;
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustment)
	salePriceAdjustment: MatterAdjustmentSalePrice;
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustmentCalculated)
	salePriceCalculated: MatterAdjustmentSalePriceCalculated;
	@ViewSelectSnapshot(AdjustmentsSelector.tarionWarrantyAdjustment)
	tarrionAdjustment: MatterAdjustmentTarion;
	@SelectSnapshot(SelectedMatter.matterHST) hst: number;
	@ViewSelectSnapshot(SelectedMatter.closingDate) closingDate: string;

	public netOutHstOptions = NetOutHstOptions;
	public tarionSaleAmountOptions = TarionSaleAmountOptions;
	public enrolmentDateOptions = EnrolmentDateOptions;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: TarionDialogData,
		private dialogRef: MatDialogRef<TarrionWarrantyDialogComponent>,
		private adjustmentDispatch: AdjustmentsDispatch,
	) {
		this.id = data.adjustmentId;
	}

	ngOnInit(): void {
		this.adjustment = {
			...cloneDeep(DefaultMatterAdjustmentTarion),
			details: this.adjustmentDetails,
		};

		// if the Sale Price adjustment is not netting out HST, change the sale price to `agreed`
		if (
			this.salePriceAdjustment.netOutHst === this.netOutHstOptions.NO ||
			this.salePriceAdjustment.netOutHst ===
				this.netOutHstOptions.NO_SALE_PRICE_HST ||
			this.salePriceAdjustment.netOutHst ===
				this.netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
		) {
			this.adjustment.saleAmount = TarionSaleAmountOptions.AGREED;
		}
		this.creditAmount = 0;

		if (this.id) {
			this.adjustment = cloneDeep(this.tarrionAdjustment);
		}
		this.changed();
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	changed(): void {
		[this.creditAmount, this.hstAmount, this.enrolmentFee] =
			calculateTarionWarranty(
				this.adjustment.credit,
				this.adjustment.rateTable,
				this.adjustment.saleAmount,
				this.salePriceCalculated,
				this.adjustment.sum,
				this.adjustment.applyHst,
				this.hst,
			);
	}

	saveModal(): void {
		this.adjustmentDispatch.Set(this.adjustment);
		this.dialogRef.close();
	}
}
